import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getLangFromPath } from "../../utils/getLangFromPath ";

export const fetchProperties = createAsyncThunk(
  "properties/fetchProperties",
  async (params, thunkAPI) => {
    try {
      const url = "https://eliteluxora.vps.webdock.cloud/api/property/get-properties";
      const lang = getLangFromPath();

      const response = await axios.get(url, {
        params, // axios will automatically convert this to query string
        headers: {
          "Accept-Language": lang,
        },
      });

      return {
        totalPages: response?.data?.total_pages,
        currentPage: response?.data?.current_page,
        properties: response?.data?.properties,
      };
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);


export const addFavourite = createAsyncThunk(
  "properties/addFavourite",
  async ({ property_id, token }, thunkAPI) => {
    if (!token) {
      console.log("No token provided, user not logged in.");

      return thunkAPI.rejectWithValue("User not logged in");
    }

    try {
      const lang = getLangFromPath();
      const response = await axios.post(
        `https://eliteluxora.vps.webdock.cloud/api/user/add-to-favorite`,
        {
          property_id,
        },
        {
          headers: {
            "Accept-Language": lang,
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const removeFavourite = createAsyncThunk(
  "favorites/removeFavourite",
  async ({ property_id, token }, { rejectWithValue }) => {
    try {
      const lang = getLangFromPath();
      const response = await axios.delete(
        `https://eliteluxora.vps.webdock.cloud/api/user/remove-from-favorite`,
        {
          headers: {
            "Accept-Language": lang,
            Authorization: `Bearer ${token}`,
          },
          data: {
            property_id,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const propertiesSlice = createSlice({
  name: "properties",
  initialState: {
    properties: [],
    favourites: [],
    totalPages: 0,
    filters: {},
    currentPage: 1,
    loading: false,
    error: null,
  },
  reducers: {
    setFavourites: (state, action) => {
      state.favourites = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    Resetproperties: (state) => {
      state.properties = [];
      state.favourites = [];
      state.totalPages = 0;
      state.filters = {};
      state.currentPage = 1;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProperties.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProperties.fulfilled, (state, action) => {
        state.properties = action.payload.properties;
        state.totalPages = action.payload.totalPages;
        state.currentPage = action.payload.currentPage;
        state.loading = false;
      })
      .addCase(fetchProperties.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addFavourite.fulfilled, (state, action) => {
        state.favourites.push(action.payload);
        state.loading = false;
      })
      .addCase(removeFavourite.fulfilled, (state, action) => {
        state.favourites = state.favourites.filter(
          (id) => id !== action.meta.arg.property_id
        );
        state.loading = false;
      });
  },
});

export const selectProperties = (state) => state.properties.properties;
export const selectPropertiesLoading = (state) => state.properties.loading;
export const selectPropertiesError = (state) => state.properties.error;

export default propertiesSlice.reducer;
export const { setFavourites, setFilters ,Resetproperties} = propertiesSlice.actions;
